import React, { useState } from "react";
import axios from "axios";
import "../assets/expo_landing_page.css";

import county from "../assets/imgs/home.webp";

export default function RichCounty() {

    const [form, setForm] = useState({
        name: "",
        mobile: "",
        city: "",
        budget: "",
        project: "Samriddhi Rich County – 3 BHK Homes"
    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (form.mobile.length !== 10) {
            alert("Enter valid mobile number");
            return;
        }

        setLoading(true);

        try {
            const res = await axios.post(
                "https://samriddhidevelopers.in/backend/expo_lead.php",
                form,
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            if (res.data.status === "success") {

                const message = `Hi, I am ${form.name}. Interested in Samriddhi Rich County (3 BHK Homes). Budget: ${form.budget}. I want details.`;

                const encoded = encodeURIComponent(message);

                setTimeout(() => {
                    window.location.href = `https://wa.me/919766010099?text=${encoded}`;
                }, 800);

            } else {
                alert("Failed to save lead");
            }

        } catch (err) {
            console.error(err);
            alert("Server error");
        }

        setLoading(false);
    };

    return (
        <div className="expo-page">

            {/* HERO */}
            <section
                className="expo-hero"
                style={{ backgroundImage: `url(${county})` }}
            >
                <div className="expo-overlay">
                    <h1 className="expo-heading">
                        Samriddhi Rich County
                    </h1>

                    <p className="expo-sub">
                        Premium 3 BHK Homes for Modern Living
                    </p>

                    <button
                        className="expo-primary-btn"
                        onClick={() =>
                            document.getElementById("form").scrollIntoView({ behavior: "smooth" })
                        }
                    >
                        Book Your Home
                    </button>
                </div>
            </section>

            {/* HIGHLIGHTS */}
            <section className="expo-projects">
                <h2 className="section-title">Project Highlights</h2>

                <div className="expo-grid">
                    <div className="expo-card">3 BHK Premium Homes 🏡</div>
                    <div className="expo-card">Modern Architecture</div>
                    <div className="expo-card">Excellent Connectivity 🚗</div>
                    <div className="expo-card">Ideal for Families</div>

                </div>
            </section>

            {/* FORM */}
            <section id="form" className="expo-form-section">
                <h2 className="expo-section-title-white">
                    Get Price & Site Visit Details
                </h2>

                <form className="expo-form" onSubmit={handleSubmit}>

                    <input
                        name="name"
                        placeholder="Your Name"
                        onChange={handleChange}
                        required
                    />

                    <input
                        name="mobile"
                        placeholder="Mobile Number"
                        onChange={handleChange}
                        required
                    />

                    <input
                        name="city"
                        placeholder="City"
                        onChange={handleChange}
                        required
                    />

                    <select name="budget" onChange={handleChange} required>
                        <option value="">Select Budget</option>

                        <option>1Cr</option>
                        <option>1Cr+</option>
                    </select>

                    <button
                        type="submit"
                        className="expo-primary-btn"
                        disabled={loading}
                    >
                        {loading ? "Submitting..." : "Get Details on WhatsApp"}
                    </button>

                </form>
            </section>

        </div>
    );
}